import React from "react";
import siteConfig from "site-config";
import { $, merge } from "glamor";

export const WhatIsDeployed: React.FC<{}> = React.memo(() => {
    const [closed, setClosed] = React.useState(false);

    const styles = merge(
        {
            position: "fixed" as "fixed",
            display: "flex",
            bottom: "0",
            zIndex: 2900,
            left: "0",
            backgroundColor: "rgba(0, 0, 0, .8)",
            alignItems: "center",
            padding: "0 8px",
        },
        $(" a", {
            padding: "0 8px 0 0",
            lineHeight: "24px",
            color: "white",
            display: "block",
        }),
        $(" button", {
            border: "none",
            padding: "0",
            outline: "none",
            height: "24px",
            lineHeight: "24px",
            color: "white",
            backgroundColor: "transparent",
            textAlign: "center" as "center",
        }),
    );

    if (!siteConfig.refName || closed) {
        return null;
    }

    return (
        <div {...styles}>
            <a href={`mailto: ${siteConfig.deployedBy}`}>{siteConfig.refName}</a>
            <button onClick={() => setClosed(true)}>X</button>
        </div>
    );
});
